
<script setup lang="ts">
import useContainer, {type ContainerProps, containerProps} from "./Container";
import type {Flow} from "@t/fd/layout/Flow";
import {computed} from "vue";

const uprops = defineProps({ ...containerProps });
const props = uprops as ContainerProps;

const flow = computed<Flow>(() => props.part as Flow);
const { visible, componentOfPart, partRef, localData, ro, vm, clazz, style } = useContainer(props);
</script>

<template>
	<div class="fd-flow" v-if="visible" :class="clazz" :style="style">
		<template v-for="item in flow.items">
			<component :is="componentOfPart(item)" :part="partRef(item)" :data="localData" :readonly="ro" :viewmode="vm"></component>
		</template>
	</div>
</template>

<style>
.fd-flow {
	display: flex;
	flex-flow: row nowrap;
	align-items: baseline;
	column-gap: var(--input-spacing);
	row-gap: var(--form-v-padding);

	& > input[type=text],
	& > input[type=email],
	& > input[type=tel],
	& > input[type=url],
	& > select {
		flex-grow: 1;
		flex-shrink: 1;
		min-width: 40px;
	}
}
</style>
